import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 項目名 */
enum OrderItem {
  code = '1',
  name = '2',
  spareName01 = '3',
  spareName02 = '4',
}

const nameConfig = {
  code: new Map([
    [Locale.ja, 'コード'],
    [Locale.en, 'Code'],
  ]),
  name: new Map([
    [Locale.ja, '名称'],
    [Locale.en, 'Name'],
  ]),
  spareName01: new Map([
    [Locale.ja, '予備名称1'],
    [Locale.en, 'Spare Name 01'],
  ]),
  spareName02: new Map([
    [Locale.ja, '予備名称2'],
    [Locale.en, 'Spare Name 02'],
  ]),
};

const toEnum = rawValueToEnum(OrderItem, OrderItem.code);
const toDisplay = enumToName(OrderItem, nameConfig);
const toDisplayWithPrefix = enumToName(OrderItem, nameConfig, { prefix: true });

export const orderItem = {
  enum: OrderItem,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OrderItem };
